import React, { useState, useEffect } from 'react';

import SignIn from './pages/SignIn';
import BuyGame from './pages/BuyGame';
import RecoverPassword from './pages/RecoverPassword';
import ChangePassword from './pages/ChangePassword';
import Loading from './pages/Loading';
import Main from './pages/Main'
import authApi from './api/auth';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

function App() {
  const [ signIn, setSignIn ] = useState(false);
  const [ loading, setLoading ] = useState(true);
  
  useEffect(() => {
    authApi.check()
    .then(_ => {
      setSignIn(true);
    }).catch(_ => {
      setSignIn(false);
    }).finally(_ => {
      setLoading(false);
    });
  }, []);

  if(loading) {
    return <Loading />
  }

  const signInHandler = (successful) => {
    setSignIn(successful);
  }

  return <Router>
    <Switch>
      <Route path="/recover_password">
        {
          !signIn ? <RecoverPassword /> : <Redirect to="/main" />
        }
      </Route>
      <Route path="/change_password">
        {
          !signIn ? <ChangePassword /> : <Redirect to="/main" />
        }
      </Route>
      <Route path="/buy_game">
        {
          !signIn ? <BuyGame signInHandler={signInHandler} /> : <Redirect to="/main" />
        }  
      </Route>
      <Route path="/sign_in">
        {
          !signIn ? <SignIn signInHandler={signInHandler} /> : <Redirect to="/main" />
        }  
      </Route>
      <Route path="/main">
        {
          signIn ? <Main signInHandler={signInHandler} /> : <Redirect to="/sign_in" />
        }  
      </Route>
      <Route path="/">
        {
          signIn ? <Redirect to="/main" /> : <Redirect to="/sign_in" />
        }
      </Route>
    </Switch>
  </Router>
}

export default App;
